import React, { Component } from "react";
import "./CommentsList.scss";
import { ReactComponent as DeleteIcon } from "../../../../assets/svg/delete.svg";
import moment from "moment";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import Flag from "semantic-ui-react/dist/es/elements/Flag";
import { ReactComponent as UpIcon } from "../../../../assets/svg/up-arrow.svg";
import { ReactComponent as CuraCao } from "../../../../assets/svg/curacao.svg";
import { ReactComponent as BonaireIcon } from "../../../../assets/svg/bonaire.svg";
import { ReactComponent as GlobeIcon } from "../../../../assets/svg/globe-icon.svg";
import { ReactComponent as Guernsey } from "../../../../assets/svg/guernsey.svg";
import { ReactComponent as Isleofman } from "../../../../assets/svg/Isleofman.svg";
import { ReactComponent as Bostonian } from "../../../../assets/svg/bostonian.svg";
import { ReactComponent as UnknownFlag } from "../../../../assets/svg/unknown-flag.svg";
import { ReactComponent as SintMarteen } from "../../../../assets/svg/sint-maarten.svg";
import { ReactComponent as SouthSudan } from "../../../../assets/svg/South-Sudan.svg";
import { ReactComponent as Jersey } from "../../../../assets/svg/jersey.svg";
import { ReactComponent as SaintBarthelemy } from "../../../../assets/svg/Saint-Barthelemy.svg";
import { ReactComponent as NoAccount } from "../../../../assets/svg/no-account.svg";
import { Scrollbars } from "react-custom-scrollbars";

class CommentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortBy: "",
            sortDirection: "",
        };
    }
    getCountryById = (_countryId) => {
        try {
            // let countries = JSON.parse(localStorage.getItem("filterOptions")).countries || [];
            let countries = this.props.allLocations || [];
            if (countries.length > 0) {
                let countryInfo = countries.filter((x) => x.id === _countryId);
                return countryInfo[0].name;
            } else return "";
        } catch (exp) {
            return "";
        }
    };
    getCountryCode = (_countryId) => {
        try {
            // let countries = JSON.parse(localStorage.getItem("filterOptions")).countries || [];
            let countries = this.props.allLocations || [];
            let countryInfo = countries.filter((x) => x.id === _countryId);
            if (countryInfo.length > 0) return countryInfo[0].short_name.toLowerCase();
            else return "";
        } catch (exp) {
            return "";
        }
    };

    searchFilter = () => {
        //filter
        let searchText = this.props.fbCommentSearchText;
        let sortByColumn = this.state.sortBy;
        let sortDirection = this.state.sortDirection;
        let _fbCommentsListData = this.props.fbCommentsList;
        let fbCommentsListData = [...this.props.fbCommentsList];
        if (searchText === "" && sortByColumn === "") return _fbCommentsListData;
        let filterData = [];
        if (searchText !== "") {
            let filterKeyword = searchText.toLowerCase().trim();
            filterData = fbCommentsListData.filter((ele) => {
                return (
                    ele.post_url.toLowerCase().indexOf(filterKeyword) > -1 || this.getCountryById(ele.country_id).toLowerCase().indexOf(filterKeyword) > -1
                    // moment(ele.created_date).format("YYYY-MM-DD").toLowerCase().indexOf(filterKeyword) > -1 ||
                    // (ele.one_time_fetch === 1 ? "yes" : "no").toLowerCase().indexOf(filterKeyword) > -1
                );
            });
            if (sortByColumn === "") return filterData;
        }
        //sorting
        if (sortByColumn !== "" && sortDirection !== "") {
            let dataToBeSorted = sortByColumn !== "" && searchText !== "" ? filterData : fbCommentsListData;
            let order = sortDirection === "asc" ? 1 : -1;
            if (sortByColumn == "post_url") {
                filterData = dataToBeSorted.sort((a, b) => {
                    if (a.post_url.toLowerCase() > b.post_url.toLowerCase()) {
                        return 1 * order;
                    }
                    if (a.post_url.toLowerCase() < b.post_url.toLowerCase()) {
                        return -1 * order;
                    }
                    return 0;
                });
            }
            if (sortByColumn == "country_id") {
                filterData = dataToBeSorted.sort((a, b) => {
                    if (this.getCountryById(a.country_id).toLowerCase() > this.getCountryById(b.country_id).toLowerCase()) {
                        return 1 * order;
                    }
                    if (this.getCountryById(a.country_id).toLowerCase() < this.getCountryById(b.country_id).toLowerCase()) {
                        return -1 * order;
                    }
                    return 0;
                });
            }
            // if (sortByColumn == "one_time_fetch") {
            //     filterData = dataToBeSorted.sort((a, b) => order * (a.one_time_fetch - b.one_time_fetch));
            // }
            // if (sortByColumn == "created_date") {
            //     filterData = dataToBeSorted.sort((a, b) => order * (moment(a.created_date) - moment(b.created_date)));
            // }
            return filterData;
        }
    };
    customFlagRenderer = (name) => {
        if (name === "Curacao") {
            return (
                <span>
                    <CuraCao className="custom-icon" />
                </span>
            );
        } else if (name === "Bonaire, Sint Eustatius and Saba") {
            return (
                <span>
                    <BonaireIcon className="custom-icon" />
                </span>
            );
        } else if (name === "Guernsey") {
            return (
                <span>
                    <Guernsey className="custom-icon" />
                </span>
            );
        } else if (name === "Jersey") {
            return (
                <span>
                    <Jersey className="custom-icon" />
                </span>
            );
        } else if (name === "Isle of Man") {
            return (
                <span>
                    <Isleofman className="custom-icon" />
                </span>
            );
        } else if (name === "Millennium Bostonian") {
            return (
                <span>
                    <Bostonian className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Martin") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Sint Maarten") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Barthelemy") {
            return (
                <span>
                    <SaintBarthelemy className="custom-icon" />
                </span>
            );
        } else if (name == "Worldwide") {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        } else if (name === "South Sudan") {
            return (
                <span>
                    <SouthSudan className="custom-icon" />
                </span>
            );
        } else if (name == "Unknown") {
            return (
                <span>
                    <UnknownFlag className="custom-icon" />
                </span>
            );
        } else {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        }
    };

    flagRenderer = (item) => <Flag className="flag_icon" name={item} />;

    getSortClassNamesFor = (_sortBy) => {
        let sortDirection = this.state.sortDirection;
        let sortBy = this.state.sortBy;
        if (sortDirection === "asc" && sortBy === _sortBy) {
            this.setState({ sortDirection: "desc", sortBy: _sortBy });
        } else if (sortDirection === "asc" && sortBy !== _sortBy) {
            this.setState({ sortDirection: "asc", sortBy: _sortBy });
        } else if (sortDirection === "desc" && sortBy === _sortBy) {
            this.setState({ sortDirection: "", sortBy: "" });
        } else if (sortDirection === "desc" && sortBy !== _sortBy) {
            this.setState({ sortDirection: "asc", sortBy: _sortBy });
        } else if (sortDirection === "") {
            this.setState({ sortDirection: "asc", sortBy: _sortBy });
        }
    };
    render() {
        let fbCommentsList = this.searchFilter();
        let flagMissingCountries = [
            "Curacao",
            "Bonaire, Sint Eustatius and Saba",
            "Guernsey",
            "Isle of Man",
            "Millennium Bostonian",
            "Jersey",
            "Saint Martin",
            "Sint Maarten",
            "Worldwide",
            "South Sudan",
            "Saint Barthelemy",
            "Unknown",
        ];
        return (
            <div className="commentList">
                <div className="comments__table-header">
                    <div className="post__url">
                        Post Url{" "}
                        <span
                            className={`short__persist ${
                                this.state.sortBy == "post_url" ? (this.state.sortDirection === "asc" ? "short__rotateUp" : "short__rotateDown") : ""
                            }`}
                            onClick={() => this.getSortClassNamesFor("post_url")}>
                            {" "}
                            {<UpIcon />}
                        </span>
                    </div>
                    <div className="country__name">
                        Country{" "}
                        <span
                            className={`short__persist ${
                                this.state.sortBy == "country_id" ? (this.state.sortDirection === "asc" ? "short__rotateUp" : "short__rotateDown") : ""
                            }`}
                            onClick={() => this.getSortClassNamesFor("country_id")}>
                            {<UpIcon />}
                        </span>
                    </div>
                    {/* <div className="added__on">
                        <Popup content="YYYY-MM-DD" trigger={<span>Added On </span>} size="mini" position="top center" inverted />
                        <span
                            className={`short__persist ${
                                this.state.sortBy === "created_date" ? (this.state.sortDirection === "asc" ? "short__rotateUp" : "short__rotateDown") : ""
                            }`}
                            onClick={() => this.getSortClassNamesFor("created_date")}>
                            {" "}
                            {<UpIcon />}
                        </span>
                    </div> */}
                    {/* <span className="fetch__once">
                        Fetch Once{" "}
                        <span
                            className={`short__persist ${
                                this.state.sortBy === "one_time_fetch" ? (this.state.sortDirection === "asc" ? "short__rotateUp" : "short__rotateDown") : ""
                            }`}
                            onClick={() => this.getSortClassNamesFor("one_time_fetch")}>
                            {" "}
                            {<UpIcon />}
                        </span>
                    </span> */}
                    <span className="delete__action">
                        <span className="delete-text-align">Delete</span>
                    </span>
                    {/* <span className={fbCommentsList.length > 5 ? "extra_width" : ""}></span> */}
                </div>

                {fbCommentsList.length > 0 && (
                    <div className="comments__table-body">
                        <Scrollbars autoHide>
                            {fbCommentsList.map((elem, ind) => {
                                return (
                                    <div className="table__row" key={ind}>
                                        <div className="post__url">{elem.post_url}</div>
                                        <div className="country__name">
                                            {flagMissingCountries.includes(this.getCountryById(elem.country_id))
                                                ? this.customFlagRenderer(this.getCountryById(elem.country_id))
                                                : this.flagRenderer(this.getCountryCode(elem.country_id))}
                                            {this.getCountryById(elem.country_id)}
                                        </div>
                                        {/* <div className="added__on">
                                            <Popup
                                                trigger={<span>{moment(elem.created_date).format("YYYY-MM-DD")}</span>}
                                                content={moment(elem.created_date).tz(this.props.userTimeZone).format("YYYY-MM-DD HH:mm:ss z")}
                                                size="mini"
                                                position="right center"
                                                inverted
                                            />
                                        </div> */}
                                        {/* <span className="fetch__once">{elem.one_time_fetch === 1 ? "YES" : "NO"}</span> */}
                                        <span className="delete__action">
                                            <span
                                                // className={`delete-comment  ${this.props.postUrlTobeDeleted.id === elem.id ? "deleting-comment" : ""}`}
                                                className={`delete-comment `}
                                                onClick={() => {
                                                    this.props.deletePost(ind);
                                                }}>
                                                <DeleteIcon />
                                            </span>
                                        </span>
                                    </div>
                                );
                            })}
                        </Scrollbars>
                    </div>
                )}

                {this.props.fbCommentsListLoading && (
                    <div className="list-loading">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                )}
                {fbCommentsList.length == 0 && !this.props.fbCommentsListLoading && (
                    <div className="no-data">
                        <NoAccount />
                        <p>No Posts Added Yet</p>
                    </div>
                )}
            </div>
        );
    }
}

export default CommentList;
